import React, { useState, useEffect } from "react";
import "./Factory.css";
import WhatsappChatbot from "../common-components/chatbot/Chatbot";
import { getAllGallerys } from "../../utils/apis/galleryshow/GalleryShow";
import { IDS } from "../../utils/common";

const galleryMedia = [
  {
    type: "image",
    src: "/assets/images/factory/img1.jpeg",
  },
  {
    type: "image",
    src: "/assets/images/factory/img2.jpeg",
  },
  {
    type: "video",
    src: "/assets/images/factory/factory-video.mp4",
  },
  {
    type: "image",
    src: "/assets/images/factory/img3.jpeg",
  },
  {
    type: "video",
    src: "/assets/images/factory/factory-video-2.mp4",
  },
  {
    type: "image",
    src: "/assets/images/factory/img4.jpeg",
  },
];

const Factory = () => {
  const [ourFactory, setOurFactory] = useState([]);

  const getOurFactories = async () => {
    try {
      const res = await getAllGallerys();

      if (res?.success) {
        setOurFactory(res?.data || []);
      }
    } catch (error) {
      console.error("Error fetching our factory:", error);
    }
  };

  useEffect(() => {
    getOurFactories();
  }, []);

  return (
    <section className="gallery_section py-5">
      <div className="container">
        {/* TITLE */}
        <div className="text-center mb-5">
          <h2 className="gallery_title">Our Factory</h2>

          <p className="gallery_subtitle">Explore our Results.</p>
        </div>

        <WhatsappChatbot />

        {/* GALLERY */}
        <div className="row">
          {/* {ourFactory?.map((item, index) => (
            <div
              className="col-lg-4 col-md-4 col-sm-6 mb-4"
              key={index}
            >
              <div className="gallery_card">

                {item.type === "image" ? (
                  <img
                    src={IDS?.IMG_URL + item?.image}
                    alt={`Factory Gallery ${index + 1}`}
                    className="gallery_img"
                  />
                ) : (
                  <video
                    className="gallery_img gallery_video"
                    src={IDS?.IMG_URL + item?.image}
                    controls
                    muted
                    playsInline
                    preload="metadata"
                  />
                )}

              </div>
            </div>
          ))} */}

          {ourFactory?.map((item, index) => {
            const extension = item?.image
              ?.split(".")
              .pop()
              ?.toLowerCase();

            const videoExtensions = ["mp4", "webm", "ogg", "mov", "avi", "mkv"];

            const isVideo = videoExtensions.includes(extension);

            return (
              <div
                className="col-lg-4 col-md-4 col-sm-6 mb-4"
                key={item?.id || index}
              >
                <div className="gallery_card">
                  {isVideo ? (
                    <video
                      className="gallery_img gallery_video"
                      src={IDS?.IMG_URL + item?.image}
                      controls
                      playsInline
                      preload="metadata"
                    />
                  ) : (
                    <img
                      src={IDS?.IMG_URL + item?.image}
                      alt={`Factory Gallery ${index + 1}`}
                      className="gallery_img"
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Factory;
